module.exports = __webpack_public_path__ + "media/images/lb/734-7e0fe66a2f299d1ceb7203aba6d2cbf4.svg";